import { useMutation } from "@tanstack/react-query";
import {
  CreateExpenseAndIncomeCategoryFormType,
  CreateExpenseAndIncomeCategoryResponse,
  CreateExpenseAndIncomeSubCategoryFormType,
  CreateExpenseAndIncomeSubCategoryResponse,
  CreateExpenseAndIncomeTypeFormType,
  CreateExpenseAndIncomeTypeResponse,
  DeleteExpenseAndIncomeCategoryRequestBody,
  DeleteExpenseAndIncomeCategoryResponse,
  DeleteExpenseAndIncomeSubCategoryRequestBody,
  DeleteExpenseAndIncomeSubCategoryResponse,
  DeleteExpenseAndIncomeTypeRequestBody,
  DeleteExpenseAndIncomeTypeResponse,
  EditExpenseAndIncomeCategoryFormType,
  EditExpenseAndIncomeCategoryResponse,
  EditExpenseAndIncomeSubCategoryFormType,
  EditExpenseAndIncomeSubCategoryResponse,
  EditExpenseAndIncomeTypeFormType,
  EditExpenseAndIncomeTypeResponse,
} from "./interfaces";

import queryClient from "src/config/reactQuery.config";
import {
  createExpenseAndIncomeCategory,
  createExpenseAndIncomeSubCategory,
  createExpenseAndIncomeType,
  deleteExpenseAndIncomeCategory,
  deleteExpenseAndIncomeType,
  deleteExpenseAndIncomeSubCategory,
  editExpenseAndIncomeCategory,
  editExpenseAndIncomeSubCategory,
  editExpenseAndIncomeType,
} from "src/services/ExpenseAndIncomeCategory.service";

export const useCreateExpenseAndIncomeCategory = () => {
  return useMutation<
    CreateExpenseAndIncomeCategoryResponse,
    Error,
    CreateExpenseAndIncomeCategoryFormType
  >({
    mutationFn: (value) => createExpenseAndIncomeCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["expense-and-income-category"],
      });
    },
  });
};

export const useEditExpenseAndIncomeCategory = () => {
  return useMutation<
    EditExpenseAndIncomeCategoryResponse,
    Error,
    EditExpenseAndIncomeCategoryFormType
  >({
    mutationFn: (value) => editExpenseAndIncomeCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["expense-and-income-category"],
      });
    },
  });
};

export const useDeleteExpenseAndIncomeCategory = () => {
  return useMutation<
    DeleteExpenseAndIncomeCategoryResponse,
    Error,
    DeleteExpenseAndIncomeCategoryRequestBody
  >({
    mutationFn: (value) => deleteExpenseAndIncomeCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["expense-and-income-category"],
      });
    },
  });
};

export const useCreateExpenseAndIncomeSubCategory = () => {
  return useMutation<
    CreateExpenseAndIncomeSubCategoryResponse,
    Error,
    CreateExpenseAndIncomeSubCategoryFormType
  >({
    mutationFn: (value) => createExpenseAndIncomeSubCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["expense-and-income-category"],
      });
    },
  });
};

export const useEditExpenseAndIncomeSubCategory = () => {
  return useMutation<
    EditExpenseAndIncomeSubCategoryResponse,
    Error,
    EditExpenseAndIncomeSubCategoryFormType
  >({
    mutationFn: (value) => editExpenseAndIncomeSubCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["expense-and-income-category"],
      });
    },
  });
};

export const useDeleteExpenseAndIncomeSubCategory = () => {
  return useMutation<
    DeleteExpenseAndIncomeSubCategoryResponse,
    Error,
    DeleteExpenseAndIncomeSubCategoryRequestBody
  >({
    mutationFn: (value) => deleteExpenseAndIncomeSubCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["expense-and-income-category"],
      });
    },
  });
};

export const useCreateExpenseAndIncomeType = () => {
  return useMutation<
    CreateExpenseAndIncomeTypeResponse,
    Error,
    CreateExpenseAndIncomeTypeFormType
  >({
    mutationFn: (value) => createExpenseAndIncomeType(value),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["expense-and-income-category"],
      });
    },
  });
};

export const useEditExpenseAndIncomeType = () => {
  return useMutation<
    EditExpenseAndIncomeTypeResponse,
    Error,
    EditExpenseAndIncomeTypeFormType
  >({
    mutationFn: (value) => editExpenseAndIncomeType(value),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["expense-and-income-category"],
      });
    },
  });
};

export const useDeleteExpenseAndIncomeType = () => {
  return useMutation<
    DeleteExpenseAndIncomeTypeResponse,
    Error,
    DeleteExpenseAndIncomeTypeRequestBody
  >({
    mutationFn: (value) => deleteExpenseAndIncomeType(value),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["expense-and-income-category"],
      });
    },
  });
};
